import { actionTree } from "typed-vuex";
import { ActionContext } from "vuex";
import { Response, ResponseError } from "@wl/types/lib/responses";
import { RankingRes } from "@wl/types/lib/responses/ranking/ranking.res";
import { RootState } from "..";
import getters from "./getters";
import mutations from "./mutations";
import state, { RankingState } from "./state";

type Ranking = Response<RankingRes>;
type Context = ActionContext<RankingState, RootState>;

/**
 * Ranking module actions.
 */
const actions = actionTree(
    { state, getters, mutations },
    {
        /**
         * Fetches all module data.
         *
         * @param {Context} _ Action context
         * @return {Promise<void>}
         */
        async fetch(_: Context): Promise<void> {
            await this.app.$accessor.ranking.getGlobal();
            await this.app.$accessor.ranking.getLocal();
        },

        /**
         * Fetchs the global ranking.
         *
         * @param {Context} _ Action context
         * @return {(Promise<ResponseError | undefined>)} Potential error
         */
        async getGlobal(_: Context): Promise<ResponseError | undefined> {
            const response = await this.$axios.get<Ranking>("/ranking/global");
            if (response.data.error) return response.data.error;

            this.app.$accessor.ranking.setGlobal(response.data.data?.ranking);
        },

        /**
         * Fetches the local ranking.
         *
         * @param {Context} _ Action context
         * @return {(Promise<ResponseError | undefined>)} Potential error
         */
        async getLocal(_: Context): Promise<ResponseError | undefined> {
            const response = await this.$axios.get<Ranking>("/ranking/local");
            if (response.data.error) return response.data.error;

            this.app.$accessor.ranking.setLocal(response.data.data?.ranking);
        },
    },
);

export default actions;
